import { auth } from "../services/firebase";

export async function fetchWithFirebaseAuth(url, options = {}) {
  const currentUser = auth.currentUser;

  if (!currentUser) {
    throw new Error("Sign in to use SBS AI.");
  }

  const token = await currentUser.getIdToken();
  const headers = new Headers(options.headers || {});
  headers.set("Authorization", `Bearer ${token}`);

  return fetch(url, {
    ...options,
    headers,
  });
}

export function getSbsApiErrorMessage(status, payload, fallback) {
  if (status === 401) {
    return "Sign in again to use SBS AI.";
  }

  if (status === 403) {
    return payload?.error || "Your SBS account does not have access to this AI feature.";
  }

  if (status === 429) {
    return "Too many requests. Please wait and try again.";
  }

  return payload?.error || payload?.message || fallback;
}